import React from 'react'
import { CircularProgress } from '@mui/material'

export const CommonLoader = ({
  size = 40,
  style,
  color = 'primary',
  thickness = 3.6,
}) => {
  return (
    <CircularProgress
      size={size}
      style={style}
      color={color}
      thickness={thickness}
    />
  )
}
